import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-body" }
const _hoisted_2 = { id: "footer" }

import FeaturesSection from "@/components/Home/FeaturesSection.vue";
import ShowcaseSection from "@/components/Home/ShowcaseSection.vue";
import FaqSection from "@/components/Home/FaqSection.vue";
import HeroSection from "@/components/Home/HeroSection.vue";
import HeaderSection from "@/components/Home/HeaderSection.vue"
import {useHead, useSeoMeta} from "@vueuse/head";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

useHead({
  title: 'Home',
  titleTemplate: (title?: string) => !title ? 'Default title' : `${title} - DogLink`,
  meta: [
    {
      name: "description",
      content: "Share your links your way"
    }
  ]
})

useSeoMeta({
  description: 'Share your links your way',
  ogDescription: 'Share your links your way',
  ogTitle: 'Home - Doglink',
  ogImage: '/logo.png',
  twitterCard: 'summary',
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderSection),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeroSection),
      _createVNode(FeaturesSection),
      _createVNode(ShowcaseSection),
      _createVNode(FaqSection)
    ]),
    _createElementVNode("footer", _hoisted_2, [
      _createVNode(_component_router_link, { to: "terms-of-service" }, {
        default: _withCtx(() => [
          _createTextVNode("Terms of Service")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "privacy-policy" }, {
        default: _withCtx(() => [
          _createTextVNode("Privacy Policy")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})